// extracted by mini-css-extract-plugin
export default {"btn":"Button_btn__rk-ay","primary":"Button_primary__+WKs6","second":"Button_second__s2i0F","danger":"Button_danger__4EPAC"};